import { Routes } from '@angular/router';
import { FillCvPage } from './pages/fill-cv-page';
import { HomePage } from './pages/home-page';

export const routes: Routes = [
	{ path: '', component: HomePage },
	{ path: 'fill-cv', component: FillCvPage },
	{ path: 'fill-cv/:id', component: FillCvPage },
	{ path: '**', redirectTo: '' },
];
